export const DEFAULT_LIGHT_TEXT_COLOR = "#FBFBFE";

export const DEFAULT_DARK_TEXT_COLOR = "#272522";

export const DEFAULT_TEXT_COLOR = "#000000";
